import {
  Satellite, Truck, LockKeyhole, MapPinned, Route, BellRing, FileBarChart, ClipboardCheck,
  Car, Bike, Container, ShieldCheck, Gauge, Smartphone, Headset, Building2, Leaf, Globe2, Wrench,
} from 'lucide-react';

const MAP = {
  Satellite, Truck, LockKeyhole, MapPinned, Route, BellRing, FileBarChart, ClipboardCheck,
  Car, Bike, Container, ShieldCheck, Gauge, Smartphone, Headset, Building2, Leaf, Globe2, Wrench,
};

export default function Icon({ name, className }) {
  const C = MAP[name] || Satellite;
  return <C className={className} />;
}